<template>
    <el-dialog 
        title="业务咨询" 
        :visible.sync="visible" 
        width="50%" 
        :close-on-click-modal="false" 
        class="consult-dialog">
        <div class="dialog-content">
            <el-form :model="form" ref="dialogForm" label-width="0px">
                <el-form-item class="half-width">
                    <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item class="half-width">
                    <el-input v-model="form.companyEmail" placeholder="请输入公司邮箱"></el-input>
                </el-form-item>
                <el-form-item class="half-width">
                    <el-date-picker v-model="form.appointmentTime" placeholder="请输入预约时间" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item class="half-width">
                    <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item class="half-width">
                    <el-input v-model="form.contactPerson" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item class="half-width">
                    <el-input v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
                <el-form-item class="full-width">
                    <el-input v-model="form.requirements" type="textarea" placeholder="请输入您的需求"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="form.agreement">
                        勾选表示：您同意华软及其授权的合作伙伴通过填写的联系方式联系您，且数据仅用于与您沟通。
                    </el-checkbox>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button 
                    type="primary" 
                    :disabled="!form.agreement" 
                    @click="handleSubmit">
                    提交
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ConsultDialog',
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
    },
    methods: {
        closeDialog() {
            this.$emit('update:visible', false);
        },
        handleSubmit() {
            if (!this.form.agreement) return;
            this.$refs.dialogForm.validate((valid) => {
                if (valid) {
                    this.$emit('submit');
                    this.closeDialog();
                } else {
                    console.error('表单验证失败');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.consult-dialog {
    .dialog-content {
        background-image: url('../../assets/home/ziXunDiag.png');
        background-size: cover;
        padding: 32px;
        padding-right: 245px;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        .el-button {
            margin-left: 10px;
        }
    }
}


</style>
